.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.warning {
  color: var(--color-warning);
  font-size: 1.4rem;
  line-height: 2rem;
}

.key-display {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  background: var(--color-grayscale-tuna);
  border-radius: 0.6rem;
  padding: 1.2rem 1.6rem;
}

.key-value {
  flex: 1;
  font-size: 1.3rem;
  color: var(--color-grayscale-white);
  word-break: break-all;
}
